import React from 'react';
import { Prompts } from '@beisen/chaos-ui';
class TipComponent extends React.Component {
    constructor(props) {
        super(props);
        this.hideTipHandler = this.hideTipHandler.bind(this);
        this.state = {
            show: true
        };
    }

    hideTipHandler() {
        const tipInfo = this.props.ajaxTips && this.props.ajaxTips[0];
        if(tipInfo) {
            this.props.actions.hideTipMessage(tipInfo['id']);
        }
    }

    render() {
        const tipInfo = this.props.ajaxTips && this.props.ajaxTips[0];
        return tipInfo ? <Prompts {...tipInfo} type={tipInfo.type || 'error'}  hideTipHandler={this.hideTipHandler} /> : null;
    }
}

export default TipComponent;



// WEBPACK FOOTER //
// ./src/components/Common/TipComponent.js